export const UserContext = React.createContext([undefined, () => {
  throw new Error("Update not implemented")
}])

